import { getWithToken, postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const emission_detail = apiUrl + "/emission_detail";
const routes = {
  label: "Emission Detail",
  root: emission_detail,
  get_by_emission_ids: emission_detail + "/get_by_emission_ids",
  save: emission_detail + "/save",
  new: emission_detail + "/new",
  update: emission_detail + "/update",
  delete: emission_detail + "/delete",
  duplicate: emission_detail + "/duplicate",
};

export const Emission_detail = {
  get_by_emission_ids: (ids) => getWithToken(routes.get_by_emission_ids, { ids }),
  save: (emission_details) => postWithToken(routes.save, emission_details),
  new: (emission_id) => postWithToken(routes.new, { emission_id }),
  delete: (ids) => postWithToken(routes.delete, { ids }),
  duplicate: (ids) => postWithToken(routes.duplicate, { ids }),
  update: (emission_details) => postWithToken(routes.update, emission_details),
};
